import React from 'react';
import moment from 'moment';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

// Helpers
import { getWeekDayString } from 'src/services/date';


const RescheduleDetails = (props) => {
  const { campusesList, details, t } = props;

  const renderLocations = () => {
    if (details && details.locationType) {
      if (details.locationType === 'original') {
        return <p>{t('appointment_location_option_0')}</p>;
      }
      if (details.locationType === 'newByPatient') {
        return <p>{t('appointment_location_option_2')}</p>;
      }
      if (details.locationType === 'newByUser' && Array.isArray(details.locationsIds) && Array.isArray(campusesList)) {
        return <p>{`${t('select_location')} : ${
          details.locationsIds.length === campusesList.length ? t('all_available_location')
            : campusesList.find(c => c.id === details.locationsIds[0]).name}`}</p>;
      }
    }
    return null;
  };

  return (
    details ?
      <div className="confirm-section">
        <p className="caption">{t('Rescheduling details')}</p>

        {/* ──── Date ────────────────────────────────────────────────────────────────────────────── */}
        {details && details.rescheduleDate ? <div className="row">
          <p className="label">{t('earliest_reschedule_date')}</p>
          <p>{moment(details.rescheduleDate).format('DD.MM.YYYY dddd')}</p>
        </div>
          : null}

        {/* ──── Appointment type ─────────────────────────────────────────────────────────────────────── */}
        {details && details.appointmentType ?
          <div className="row">
            <p className="label">{t('resch_appointment_type')}</p>
            {details.appointmentType === 'original' ?
              <p>{t('appoint_type_option_0')}</p> :
              <p>{`${t('appoint_type_option_1')} : ${details.appointmentTypeId || t('no_data')}`}</p>
            }
          </div>
          : null
        }

        {/* ──── Schedule type ─────────────────────────────────────────────────────────────────────── */}
        {details.schedule ? <div className="row">
          <p className="label">{t('schedule')}</p>
          {details.schedule === 'original' ?
            <p>{t('schedule_option_0')}</p> :
            <p>{`${t('schedule_option_1')} : ${details.scheduleId || t('no_data')}`}</p>
          }
        </div>
          : null}

        {/* ──── Appointment location ─────────────────────────────────────────────────────────────────── */}
        <div className="row">
          <p className="label">{t('appointment_location')}</p>
          {renderLocations()}
        </div>


        {/* ──── Appointment day of week ─────────────────────────────────────────────────────────── */}
        {details.daysOfWeekType ? <div className="row">
          <p className="label">{t('appoint_day_of_week')}</p>
          {details.daysOfWeekType === 'original' ? <p>{t('appoint_day_of_week_option_0')}</p> : null}
          {details.daysOfWeekType === 'newByUser' ? <p>{`${t('appoint_day_of_week_option_1')} : ${getWeekDayString(details.days)}`}</p> : null}
          {details.daysOfWeekType === 'newByPatient' ? <p>{t('appoint_day_of_week_option_2')} </p> : null}
        </div>
          : null}

        {/* ──── Part of day ─────────────────────────────────────────────────────────────────── */}
        {details.partOfDayType ? <div className="row">
          <p className="label">{t('appoint_part_of_day')}</p>
          {details.partOfDayType === 'original' ? <p>{t('appoint_part_of_day_option_0')}</p> : null}
          {details.partOfDayType === 'newByPatient' ? <p>{t('appoint_part_of_day_option_2')}</p> : null}
          {details.partOfDayType === 'newByUser' ?
            <p>{`${t('appoint_part_of_day_option_1')} : ${
              Array.isArray(details.partOfDay) && details.partOfDay.map(v => t(v)).join(', ') || t('no_data')}`
            }</p>
            : null}
        </div>
          : null}
      </div>
      : null
  );
};

const mapStateToProps = store => {
  const pr = store.practitioner;
  return {
    details: pr.createNewJob.specificDetails,
    campusesList: pr.common.campusesList
  };
};

export default translate()(connect(mapStateToProps)(RescheduleDetails));
